import { useSelector } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'

import { eventTypeSelector } from 'root-api'
import { ProductRefreshPreviewToggle, useShowProductRefreshToggle } from 'product_refresh'

import { MenuDropdown } from './menu_dropdown'
import { CopyLinkButton } from './copy_link_button'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/index.js?styleId=Container";
import _ContentContainer from "index-ContentContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/index.js?styleId=ContentContainer";
import _CopyLinkContainer from "index-CopyLinkContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/index.js?styleId=CopyLinkContainer";
import _MenuContainer from "index-MenuContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/index.js?styleId=MenuContainer";
import _ProductRefreshToggleContainer from "index-ProductRefreshToggleContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/index.js?styleId=ProductRefreshToggleContainer";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const ContentContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
})

const CopyLinkContainer = /*#__PURE__*/styled('div', null, {
  displayName: "CopyLinkContainer",
  styles: _CopyLinkContainer
})

const MenuContainer = /*#__PURE__*/styled('div', null, {
  displayName: "MenuContainer",
  styles: _MenuContainer
})

const ProductRefreshToggleContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ProductRefreshToggleContainer",
  styles: _ProductRefreshToggleContainer
})

export const BookingPageHeader = () => {
  const eventType = useSelector(eventTypeSelector)
  const isPhone = useDeviceType('isPhone')
  const showProductRefreshToggle = useShowProductRefreshToggle()

  return (
    <Container>
      <ContentContainer isPhone={isPhone}>
        {showProductRefreshToggle && (
          <ProductRefreshToggleContainer>
            <ProductRefreshPreviewToggle showBorder />
          </ProductRefreshToggleContainer>
        )}
        <MenuContainer>
          <MenuDropdown />
        </MenuContainer>
        <CopyLinkContainer>
          <CopyLinkButton
            eventType={eventType}
          />
        </CopyLinkContainer>
      </ContentContainer>
    </Container>
  )
}
